// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HZA6z","img":"styles_img__xsIXg"};